import { Button, Field, FieldError, FieldLabel, Input } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { useForm } from '@tanstack/react-form';
import { normalisiereTitel } from '../hooks/useZugangTitelVergeben.ts';

type TitelFormularProps = {
  startTitel: string;
  vergebeneTitel: string[];
  auswahlVorhanden: boolean;
  absendenText: string;
  laeuft: boolean;
  onAbsenden: (titel: string) => void;
};

export function TitelFormular({
  startTitel,
  vergebeneTitel,
  auswahlVorhanden,
  absendenText,
  laeuft,
  onAbsenden,
}: TitelFormularProps) {
  const { t } = useTranslation();

  const form = useForm({
    defaultValues: { titel: startTitel },
    onSubmit: ({ value }) => onAbsenden(value.titel),
  });

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        form.handleSubmit();
      }}>
      <form.Field
        name="titel"
        validators={{
          onChange: ({ value }) =>
            vergebeneTitel.includes(normalisiereTitel(value))
              ? t('domain.e2nApi.karte.titelVergeben')
              : undefined,
        }}>
        {(field) => (
          <Field>
            <FieldLabel htmlFor={field.name}>
              {t('domain.e2nApi.karte.titel')}
            </FieldLabel>
            <Input
              id={field.name}
              name={field.name}
              value={field.state.value}
              aria-invalid={field.state.meta.errors.length > 0}
              placeholder={t('domain.e2nApi.karte.titelPlaceholder')}
              onBlur={() => {
                field.setValue(field.state.value?.trim() ?? '');
                field.handleBlur();
              }}
              onChange={(event) => field.handleChange(event.target.value)}
            />
            {findFehler(field.state.meta.errors) && (
              <FieldError>{findFehler(field.state.meta.errors)}</FieldError>
            )}
          </Field>
        )}
      </form.Field>

      <form.Subscribe
        selector={(state) => ({
          gueltig: state.canSubmit,
          titel: state.values.titel,
        })}>
        {({ gueltig, titel }) => (
          <Button
            type="submit"
            className="mt-4 w-full"
            disabled={
              !gueltig || laeuft || !auswahlVorhanden || titel.trim() === ''
            }>
            {absendenText}
          </Button>
        )}
      </form.Subscribe>

      <p className="mt-3 text-center text-xs text-neutrals-700">
        {t('domain.e2nApi.karte.fussnote')}
      </p>
    </form>
  );
}

function findFehler(fehler: unknown[]): string | undefined {
  return fehler.find((eintrag) => typeof eintrag === 'string');
}
